import React from 'react';

import PropTypes from 'prop-types';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

import { getReplyStatus } from 'utils/contact';


const MessagesPopover = props => (
  <UncontrolledPopover
    className="zindex-modal"
    trigger="legacy"
    placement="auto"
    target={`popover-replies-${props.uuid}-${props.seqContact.id}`}
    delay={0}
    role="tooltip"
  >
    <PopoverBody>
      {props.seqContact.replies.map((repl, i) => (
        <React.Fragment key={repl.id}>
          Replied <span>{getReplyStatus(repl).status}</span> on&nbsp;
          <span>{repl.campaign_name}</span> in sequence <span>{repl.sequence_name}</span>
          {i + 1 !== props.seqContact.replies.length && <hr className="mtb-25" />}
        </React.Fragment>
      ))}
    </PopoverBody>
  </UncontrolledPopover>
);


MessagesPopover.propTypes = {
  uuid: PropTypes.string.isRequired,
  seqContact: PropTypes.shape({
    id: PropTypes.string,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    replies: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      sequence_name: PropTypes.string,
      campaign_name: PropTypes.string,
      status_interested_date: PropTypes.string,
      status_not_interested_date: PropTypes.string,
      status_sponsorship_date: PropTypes.string,
      status_unsubscribed_date: PropTypes.string,
      status_not_now_date: PropTypes.string,
    })).isRequired,
  }).isRequired,
};


export default MessagesPopover;
